import React from "react";
import "./MessageCard.css";

export default function MessageCard({ image, name, designation, message }) {
    return (
        <div className="message-card">
            <img src={image} alt={name} className="message-card-image" />

            <div className="message-card-content">
                <p className="message-card-text">"{message}"</p>
                <div className="message-card-footer">
                    <h3 className="message-card-name">{name}</h3>
                    <p className="message-card-designation">{designation}</p>
                </div>
            </div>
        </div>
    );
}
